import React, { ReactNode, useEffect, useState } from 'react';
import { Spinner, Notification, NotificationStatus } from '@cp-shared-19/frontend-ui';

function WatchPromise({ promise, children }: { promise: Promise<Error | void[]>; children: ReactNode }) {
    const [ready, setReady] = useState(false);
    const [spinnerPossible, setSpinnerPossible] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const timer = setTimeout(() => {
            setSpinnerPossible(true);
        }, 500); // show spinner only after 0,5s to avoid flickering
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        const f = async () => {
            const result = await promise;
            if (result instanceof Error) {
                setError(result.message);
            } else {
                setReady(true);
            }
        };
        f();
    }, []);

    if (error.length > 0) {
        return <Notification status={NotificationStatus.error} headline={error} />;
    }
    if (!ready) {
        if (!spinnerPossible) {
            return <></>;
        } else {
            return (
                <div>
                    <Spinner center fullPage />
                </div>
            );
        }
    }

    return <>{children}</>;
}

export default WatchPromise;
